import React, { Component } from 'react';

class BackendFooter extends Component {
  render() {
    return (
      <footer className="pc-footer">
        <div className="footer-wrapper container-fluid">
          <div className="row">
            
            <div className="col my-1">
              <p className="m-0">
                {/* Removed empty link, not needed */}
              </p>
            </div>

            <div className="col-md-auto my-1">
              <ul className="list-inline footer-link mb-0">
                <li className="list-inline-item">
                  Powered by{" "}
                  <a href="https://bookly.com.bd/" target="_blank" rel="noreferrer">
                    Bookly
                  </a>
                </li>
              </ul>
            </div>

          </div>
        </div>
      </footer>
    );
  }
}

export default BackendFooter;